import { useState } from "react";
import { useHistory } from "react-router";
import { useAppContext } from "../../context/AuthContext";
import { PublicController, PublicControllerType } from "../../controller/public/PublicController";
import LabelsContext from "../../lang/LabelsContext";
import MessageType from "../../utils/MessageType";
import { handleErrorMessage } from "../../utils/Utils";

interface PublicServiceType {
  login: any;
  register: any;
  resetDialog: boolean;
  openResetDialog: any;
  closeResetDialog: any;
  getCountryList: any;
  countryList: any;
}

export default function PublicService(): PublicServiceType {
  const { showMessage, updateAuthData } = useAppContext();
  const [resetDialog, setResetDialog] = useState<boolean>(false);
  const [countryList, setCountryList] = useState<any>([]);
  const { axiosLogin, axiosRegister, axiosGetCountryList }: PublicControllerType = PublicController();
  const { Labels } = LabelsContext();

  const history = useHistory();

  const login = (values: any, actions: any) => {
    axiosLogin(values)
      .then((result: any) => {
        updateAuthData(result.data);
      })
      .catch((error: any) => {
        handleErrorMessage(showMessage, error);
      });
    actions.setSubmitting(false);
  };

  const register = (values: any, actions: any) => {
    axiosRegister(values)
      .then((result: any) => {
        showMessage(Labels.REGISTER_SUCCESS, MessageType.SUCCESS);
        history.push("/");
      })
      .catch((error: any) => {
        handleErrorMessage(showMessage, error);
      });
    actions.setSubmitting(false);
  };

  const getCountryList = () => {
    axiosGetCountryList()
      .then((result: any) => {
        setCountryList(result.data);
      })
      .catch((error: any) => {
        handleErrorMessage(showMessage, error);
      });
  };

  const openResetDialog = () => {
    setResetDialog(true);
  };

  const closeResetDialog = () => {
    setResetDialog(false);
  };

  return { register, login, resetDialog, openResetDialog, closeResetDialog, getCountryList, countryList };
}

export type { PublicServiceType };
